import React from "react";

export default {
    'en_CA': 'English (Canada)',
    'en_US': 'English (United States)',
    'en_GB': 'English (Great Britain)',
    'fr_CA': 'French (Canada)',
    'fr_FR': 'French (France)',
	'fr_BE': 'French (Belgium)',
	'fr_MA': 'French (Morocco)',
    'pt_PT': 'Portuguese (Portugal)',
	'el_GR': 'Greek (Greece)',
	'es_ES': 'Spanish (Spain)',
	'es_MX': 'Spanish (Mexico)',
	'es_CO': 'Spanish (Colombia)',
	'nl_BE': 'Dutch (Belgium)',
	'pt_BR': 'Portuguese (Brazil)',
	'sk_SK': 'Slovak (Slovakia)',
	'sr_RS': 'Serbian (Serbia)',
	'tr_TR': 'Turkish (Turkey)',
    'fi_FI': 'Finnish (Finland)',
    'sv_SE': 'Swedish (Sweden)',
    // GAME_SUSPENDED_MESSAGE: 'Game {0} is currently suspended...',  {0} = game name EXAMPLE WITH WILD CARD market types
    WIN_DRAW_WIN: 'Resultado da partida',
    CORRECT_SCORE: 'Pontuação correta',
    TOTAL_GOALS: 'Total de gols',
    DOUBLE_CHANCE: 'Chance dupla',
    UNDER_OVER: 'Acima/Abaixo',
    UNDER_OVER_25: 'Acima/Abaixo 2.5',
    UNDER_OVER_25_INITIALS: 'A/A 2,5',
    UNDER_OVER_35_INITIALS: 'A/A 3.5',
    UNDER_OVER_15: 'Acima/Abaixo 1.5',
    ASIAN_HANDICAP: 'Asian Handicap',
    HANDICAP: 'Handicap de 1X2',
    HANDICAP_FIRST: 'Handicap em casa de 1X2 + 1',
    HANDICAP_SECOND: 'Handicap fora de 1X2 +1',
    UNDER_OVER_05: 'Acima/Abaixo 0.5',
    UNDER_OVER_35: 'Acima/Abaixo 3.5',
    BOTH_TEAMS_SCORE: 'Ambas as equipes marcam',
    BOTH_TEAMS_SCORE_INITIALS: 'AEM',
    HOME_TEAM_GOALS: '{0} Team Goals',
    AWAY_TEAM_GOALS: '{1} Team Goals',
    MATCH_BETTING_BOTH_TEAMS_SCORE: 'Match Betting Both Teams Score',
    WINNING_MARGIN: 'Margem de ganhos',
    CORRECT_SCORE_GROUP: 'Pontuação correta Group',
    HOME_TEAM_TO_SCORE: '{0} To Score',
    AWAY_TEAM_TO_SCORE: '{1} To Score',
    FIRST_TEAM_TO_SCORE: 'Primeira equipe a marcar',
    LAST_TEAM_TO_SCORE: 'Última equipe a marcar',
    HALF_TIME_FULL_TIME: 'Intervalo final',
    TEAM_SCORECAST: 'Team Scorecast',
    HALF_TIME_CORRECT_SCORE: 'Half Time Correct Score',
    HALF_TIME_RESULT: 'Half Time Result',
    FIRST_LAST_TO_SCORE: 'First / Last to Score',
    LAST: 'Last',
    FIRST: 'First',
    IN: 'in',
    LAST_THREE_GAMES: 'Last 3 Games',
    PREVIOUS: 'Anterior',
    EIGHT_RESULTS: '8 partidas',
    EIGHT_GAMES: '8 jogos',
    OVER_25: 'Acima de 2.5',
    UNDER_25: 'Abaixo de 2.5',
    OVER_35: 'Acima de 3.5',
    UNDER_35: 'Abaixo de 3.5',
    COVERED: 'Coberto',
    DID_NOT_COVER: 'Não coberto',
    SPREAD: 'Repartição',
    TOTAL_POINTS_UNDER_OVER: 'Total de pontos abaixo/acima',
    TOTAL_POINTS_OVER_UNDER: 'Total de pontos acima/abaixo',
    MONEYLINE: 'Aposta simples',
    TOTAL_POINTS_GROUP: 'Total de pontos no agrupamento',
    MONEY_LINE_TOTAL_POINTS: 'Aposta simples e total de pontos A/A',
    SPREAD_TOTAL_POINTS: 'Repartição e total de pontos A/A',
    // countries (these are lowecase and strings on purpose)
    'Argentina': 'Argentina',
    'Belgium': 'Belgium',
    'Brazil': 'Brazil',
    'Colombia': 'Colombia',
    'Costa Rica': 'Costa Rica',
    'Croatia': 'Croatia',
    'Czech Republic': 'Czech Republic',
    'Denmark': 'Denmark',
    'Egypt': 'Egypt',
    'England': 'England',
    'France': 'France',
    'Germany': 'Germany',
    'Greece': 'Greece',
    'Holland': 'Holland',
    'Iceland': 'Iceland',
    'Italy': 'Italy',
    'Mexico': 'Mexico',
    'Poland': 'Poland',
    'Portugal': 'Portugal',
    'Republic of Ireland': 'Republic of Ireland',
    'Russia': 'Russia',
    'Spain': 'Spain',
    'Sweden': 'Sweden',
    'Switzerland': 'Switzerland',
    'Ukraine': 'Ukraine',
    'Uruguay': 'Uruguay',
    //Basketball US Teams
    'Boston': 'Boston',
    'Cleveland': 'Cleveland',
    'Houston': 'Houston',
    'Los Angeles': 'Los Angeles',
    'Orlando': 'Orlando',
    'Portland': 'Portland',
    'San Antonio': 'San Antonio',
    //Basketball Euro Teams
    'Euro Arena': 'Euro Arena',
    'Athens': 'Athens',
    'Real': 'Real',
    'Piraeus': 'Piraeus',
    'Istanbul Blues': 'Istanbul Blues',
    'Fener': 'Fener',
    'Vitoria': 'Vitoria',
    'Tel Aviv Yellows': 'Tel Aviv Yellows',
    'Moscow': 'Moscow',
    'Kaunas': 'Kaunas',
    'Barcelona City': 'Barcelona City',
    'Belgrade': 'Belgrade',
    'Lyon': 'Lyon',
    'Khimki': 'Khimki',
    'Berlin': 'Berlin',
    'St Petersburg': 'St Petersburg',
    'Valencia': 'Valencia',
    //Euro 2020 teams
    'Turkey': 'Turkey',
    'Netherlands': 'Netherlands',
    //Super league
    'Utd': 'United',
    'City': 'City',
    'Liverpool': 'Liverpool',
    'Barcelona': 'Barcelona',
    'Madrid': 'Madrid',
    'Munich': 'Munich',
    'Turin': 'Turin',
    'Milan': 'Milan',
    'Amsterdam': 'Amsterdam',
    'Paris': 'Paris',
    //NFLA
    'Pittsburgh': 'Pittsburgh',
    'Philadelphia': 'Philadelphia',
    'Denver': 'Denver',
    'New York': 'New York',
    'New England': 'New England',
    'Green Bay': 'Green Bay',
    'San Francisco': 'San Francisco',
    'Miami': 'Miami',
    'Dallas': 'Dallas',
    'Oakland': 'Oakland',
    'Chicago': 'Chicago',
    // market specific words
    'DRAW': 'Empate',
    'HD': '{0}/Empate',
    'DA': 'Empate/{1}',
    'HA': '{0}/{1}',
    'Under 2.5': 'Abaixo de 2.5',
    'Over 2.5': 'Acima de 2.5',
    'Under 1.5': 'Abaixo de 1.5',
    'Over 1.5': 'Acima de 1.5',
    'Under': 'Abaixo de {0}',
    'Over': 'Acima de {0}',
    'HOME': '{0}',
    'AWAY': '{1}',
    'Under 0.5': 'Abaixo de 0.5',
    'Over 0.5': 'Acima de 0.5',
    'Under 3.5': 'Abaixo de 3.5',
    'Over 3.5': 'Acima de 3.5',
    'Both Score Yes': 'Sim',
    'Both Score No': 'Não',
    'Home Not to Score': '{0} Not to Score',
    'Home Exactly 1': '{0} Exactly 1',
    'Home Exactly 2': '{0} Exactly 2',
    'Home Exactly 3': '{0} Exactly 3',
    'Home Exactly 4': '{0} Exactly 4',
    'Away Not to Score': '{1} Not to Score',
    'Away Exactly 1': '{1} Exactly 1',
    'Away Exactly 2': '{1} Exactly 2',
    'Away Exactly 3': '{1} Exactly 3',
    'Away Exactly 4': '{1} Exactly 4',
    'Home to Win and both teams to score': '{0} to Win and both teams to score',
    'Home to Win to nil': '{0} to Win to nil',
    'Score draw': 'Score draw',
    '0-0': '0-0',
    '0-1': '0-1',
    '0-2': '0-2',
    '0-3': '0-3',
    '0-4': '0-4',
    '0-5': '0-5',
    '0-6': '0-6',
    '1-0': '1-0',
    '2-0': '2-0',
    '3-0': '3-0',
    '4-0': '4-0',
    '5-0': '5-0',
    '6-0': '6-0',
    '1-1': '1-1',
    '2-2': '2-2',
    '3-3': '3-3',
    '2-1': '2-1',
    '1-2': '1-2',
    '3-1': '3-1',
    '1-3': '1-3',
    '3-2': '3-2',
    '2-3': '2-3',
    '4-1': '4-1',
    '1-4': '1-4',
    '4-2': '4-2',
    '2-4': '2-4',
    '5-1': '5-1',
    '1-5': '1-5',
    '1-0,2-0,2-1': '1-0,2-0,2-1',
    '3-0,3-1,4-0': '3-0,3-1,4-0',
    '1-1,2-2': '1-1,2-2',
    '0-1,0-2,1-2': '0-1,0-2,1-2',
    '0-3,1-3,0-4': '0-3,1-3,0-4',
    'Away to Win and both teams to score': '{1} to Win and both teams to score',
    'Away to Win to nil': '{1} to Win to nil',
    'Home Win By Exactly 1 Goal': '{0} Win By Exactly 1 Goal',
    'Home Win By Exactly 2 Goals': '{0} Win By Exactly 2 Goals',
    'Home Win By 3 or more goals': '{0} Win By 3 or more goals',
    'Away Win By Exactly 1 Goal': '{1} Win By Exactly 1 Goal',
    'Away Win By Exactly 2 Goals': '{1} Win By Exactly 2 Goals',
    'Away Win By 3 or more goals': '{1} Win By 3 or more goals',
    'Draw With No Goals': 'Draw With No Goals',
    'Draw With Goals': 'Draw With Goals',
    'Any Other': 'Any Other',
    'Home Not To Score': '{0} Not To Score',
    'Home To Score': '{0} To Score',
    'Away Not To Score': '{1} Not To Score',
    'Away To Score': '{1} To Score',
    'Home': '{0}',
    'No Goal': 'No Goal',
    'Away': '{1}',
    'Home/Home': '{0}/{0}',
    'Home/Draw': '{0}/Draw',
    'Home/Away': '{0}/{1}',
    'Draw/Home': 'Draw/{0}',
    'Draw/Draw': 'Draw/Draw',
    'Draw/Away': 'Draw/{1}',
    'Away/Home': '{1}/{0}',
    'Away/Draw': '{1}/Draw',
    'Away/Away': '{1}/{1}',
    'Home and 1-0': '{0} and 1-0',
    'Home and 2-0': '{0} and 2-0',
    'Home and 2-1': '{0} and 2-1',
    'Away and 2-1': '{1} and 2-1',
    'Home and 3-0': '{0} and 3-0',
    'Home and 3-1': '{0} and 3-1',
    'Away and 3-1': '{1} and 3-1',
    'Home and 4-0': '{0} and 4-0',
    'Home and 1-1': '{0} and 1-1',
    'Away and 1-1': '{1} and 1-1',
    'Home and 2-2': '{0} and 2-2',
    'Away and 2-2': '{1} and 2-2',
    'Away and 0-1': '{1} and 0-1',
    'Away and 0-2': '{1} and 0-2',
    'Away and 1-2': '{1} and 1-2',
    'Home and 1-2': '{0} and 1-2',
    'Away and 0-3': '{1} and 0-3',
    'Away and 1-3': '{1} and 1-3',
    'Home and 1-3': '{0} and 1-3',
    'Away and 0-4': '{1} and 0-4',
    'Other': 'Other',
    'Draw': 'Draw',
    // Basketball
    '120-124': '120-124',
    '125-129': '125-129',
    '130-134': '130-134',
    '135-139': '135-139',
    '140-144': '140-144',
    '145-149': '145-149',
    '150-154': '150-154',
    '155-159': '155-159',
    '160-164': '160-164',
    '165-169': '165-169',
    '170-174': '170-174',
    '175-179': '175-179',
    'Under 180': 'Abaixo de 180',
    '180-184': '180-184',
    '185-189': '185-189',
    '190-194': '190-194',
    '195-199': '195-199',
    '200-204': '200-204',
    '205-209': '205-209',
    '210-214': '210-214',
    '215-219': '215-219',
    '220-224': '220-224',
    '225-229': '225-229',
    '230-234': '230-234',
    '235-239': '235-239',
    '240-244': '240-244',
    '245-249': '245-249',
    'Over 249': 'Acima de 249',
    //American Football
    '26-30': '26-30',
    '31-35': '31-35',
    '36-40': '36-40',
    '41-45': '41-45',
    '46-50': '46-50',
    '25 And Under': 'Abaixo de 26',
    '25 And Under Short': 'Abaixo de 26',
    '51 And Over': 'Acima de 50',
    '51 And Over Short': 'Acima de 50',
    'and': '&',
    'slash': '/',
    // first down
    FIRST_PLAY: '1st Play',
    SECOND_PLAY: '2nd Play',
    THIRD_PLAY: '3rd Play',
    FOURTH_PLAY: '4th Play',
    FIFTH_PLAY: '5th or More Play',
    FIELD_GOAL: 'Field Goal',
    'PassTD on 1st Play': 'PassTD on 1st Play',
    'PassTD on 2nd Play': 'PassTD on 2nd Play',
    'PassTD on 3rd Play': 'PassTD on 3rd Play',
    'PassTD on 4th Play': 'PassTD on 4th Play',
    'PassTD on or after 5th Play': 'PassTD on or after 5th Play',
    'RunTD on 1st Play': 'RunTD on 1st Play',
    'RunTD on 2nd Play': 'RunTD on 2nd Play',
    'RunTD on 3rd Play': 'RunTD on 3rd Play',
    'RunTD on 4th Play': 'RunTD on 4th Play',
    'RunTD on or after 5th Play': 'RunTD on or after 5th Play',
    'Turnover on 1st Play': 'Turnover on 1st Play',
    'Turnover on 2nd Play': 'Turnover on 2nd Play',
    'Turnover on 3rd Play': 'Turnover on 3rd Play',
    'Turnover on 4th Play': 'Turnover on 4th Play',
    'Turnover on or after 5th Play': 'Turnover on or after 5th Play',
    'Field Goal': 'Field Goal',

    //Game Tabs
    'Football': 'Americano',
    'Matchday': 'Dia de partida',
    'Basketball': 'Basquetebol',
    'Dogs': 'Cães',
    'Motor Racing': 'Corridas motorizadas',
    'Results': 'Resultados',
    'Horses': 'Cavalos',
    'Soccer': 'Futebol',
    'US Football': 'Futebol EUA',
    'Marble Racing': 'Corrida de bolinhas',
    "Matchday_English": "Dia de partida",
    "Matchday_Turkish": "Dia de partida",
    "Matchday_Greek": "Dia de partida",

    //Game SubTabs
    'Soccer_Euro': 'Euro',
    'Soccer_Soccer3_Super_League': 'Super Liga',
    'Soccer_Soccer3_Greek_League': 'Liga Grega',
    'Soccer_Super_League': 'Super Liga',
    'Soccer_World_Cup': 'Campeonato Mundial',
    'Soccer_Soccer3_World_Cup': 'Campeonato Mundial',
    'Horses_Sprints': 'Sprints',
    'Horses_Flats': 'Nivelados',
    'Horses_Jumps': 'Saltos',
    'Basketball_US1': 'EUA',
    'Basketball_US2': 'EUA2',
    'Basketball_Europe': 'Euro',
    'Dogs_Flats': 'Nivelados',
    'Dogs_City': 'Static Odds',
    'Motor_Racing_Stock_Cars': 'Carros de produção',
    'Motor_Racing_Indy_Cars': 'Carros Indy',
    'US_Football_NFLA': 'NFLA',
    'US_Football_NFL': 'NFL',
    'US_Football_Football': 'Americano',
    'Marble_Racing_Marbles': 'Bolinhas',
    'Marble_Racing_Marbles2': 'Areia',
    'Marble_Racing_Marbles_Euro': 'Bolinhas Euro',
    'Marble_Racing_Marbles_Halloween': 'Halloween',
    "Matchday_English_Matchday_English": "Dia de partida",
    "Matchday_Turkish_Matchday_Turkish": "Dia de partida",
    "Matchday_Greek_Matchday_Greek": "Dia de partida",

    //Racing
    FORECAST: 'Previsão',
    TRICAST: 'Previsão tripla',
    REVERSE_FORECAST: 'Combination Forecast',
    REVERSE_TRICAST: 'Combination Tricast',
    FIRST_ST: '1',
    SECOND_ND: '2',
    THIRD_RD: '3',
    RD: 'º',
    ST: 'º',
    ND: 'º',
    ANY: 'Qualquer',
    TO_WIN: 'Para ganhar',
    RACE_CARD: 'CARTÃO DE CORRIDA',
    EACH_WAY: 'Conjugação de apostas',
    EW: 'CA',
    FORECAST_TRICAST: 'Previsão/Previsão tripla',
    EACH_WAY_ODDS_PLACE: 'E/W {0} 1-2',
    EACH_WAY_ODDS_SHOW: 'E/W {0} 1-2-3',
    EXPAND_ALL: 'Expand Markets',
    COLLAPSE_ALL: 'Collapse Markets',
    NUMBER: 'Número',
    SORT_BY: 'Ordenar por',
    BET_SLIP: 'Bilhete de apostas',
    CLOSE_BET_SLIP: 'Fechar',
    CLOSE_SLIP: 'Fechar',
    PLACED_BETS: 'Efetuada',
    SETTLED_BETS: 'Liquidada',
    SLIP: 'Bilhete',
    OPEN_BETS: 'Abertas',
    CLEAR_SELECTIONS: 'Limpar seleções',
    ADD_TO_BET_SLIP: 'Adicionar ao bilhete de apostas',
    NO_BETS: 'Sem apostas',
    COMBINATION_TRICAST: 'Combination Tricast',
    COMBINATION_FORECAST: 'Combination Forecast',
    TOTAL_STAKE: 'Aposta total',
    TOTAL_POTENTIAL_RETURNS: 'Lucro potencial total',
    N_A: 'N/A',
    PLACE_BETS: 'Fazer apostas',
    REMOVE_ALL: 'Remover tudo',
    POT_RETURNS: 'Pot. de lucro',
    RETURNED: 'Devolvido:',
    REFUNDED: 'Reembolsado',
    OK: 'OK',
    WIN_INITIAL: 'V',
    DRAW_INITIAL: 'E',
    LOSE_INITIAL: 'D',

    //Settings
    SETTINGS: 'Configurações',
    LANGUAGE: 'Idioma',
    LAYOUT: 'Layout',
    ODDS: 'Probabilidades',
    EN_GB: 'English UK',
    DECIMAL: 'Decimal',
    FRACTIONAL: 'Fractional',
    AMERICAN: 'Americano',
    SIMPLIFIED_DESKTOP: 'This is The main class for the desktop simplified UI',
    SIMPLIFIED_MOBILE: 'This is The main class for the mobile simplified UI',
    SHOW_VIDEO: 'Show Video',

    //Notifications
    ALERT_NOTIFICATION: 'Alerta',
    WARNING_NOTIFICATION: 'Aviso',
    WARNING_NOTIFICATION_REALITY_CHECK: 'Aviso',
    INFO_NOTIFICATION: 'INFORMAÇÕES',
    SUCCESS_NOTIFICATION: 'Sucesso',

    SELECTION_REMOVAL: 'Esta seleção será removida dentro de ',
    SECONDS: ' segundos',
    SECOND: ' segundo',
    REMOVE_CLOSED_EVENTS: 'Remover eventos fechados',
    SET_VIDEO_ON_FUL_SCREEN: 'Set Video on Full Screen?',
    CANCEL: 'Cancelar',

    //Error codes
    INTERNAL_ERROR: 'Erro interno',
    OPEN_BETS_WARNING: 'Parte apostas abertas ou todas elas não foram adicionadas ao cartão de jogo porque pertencem a eventos anteriores.',
    '-32602': 'Uma ou mais apostas não foram registradas a tempo.',
    OPEN_BETS_ON_BET_SLIP_LIMIT_REACHED: 'O número máximo de apostas no separador de bilhete de aposta foi atingido. Remova ou faça apostas antes de adicionar apostas novas.',

    '-20000': 'Cannot establish connection (Error Code: -20000)', //INIT_NOT_INVOKED
    '-20001': 'Cannot establish connection (Error Code: -20001)', //MISSING_SESSION_TOKEN
    '-20002': 'Too many requests (Error Code: -20002)', //Duplicate single shot invocation
    '-20003': 'Too many requests (Error Code: -20003)', //INVOCATION_FREQUENCY_THRESHOLD_BREACHED
    '-20004': 'Invalid Request (Error Code: -20004)', //A BmsServerAPI command was received, but the params are not compliant with Operator rules.
    '-10000': 'Invalid Request (Error Code: -10000)', //INVALID_SESSION_TOKEN
    '-10001': 'Invalid Request (Error Code: -10001)', //INBOUND_MESSAGE_QUEUE_FULL
    '-1000': 'O jogo foi suspenso. Entre em contato com o atendimento ao cliente.',
    '-999': 'Sessão expirada.',
    '-998': 'Jogador suspenso',
    '-997': 'Comando não permitido',
    '-996': 'Error processing request (Error Code: -996)', //Gaming System Error
    '-995': 'Error processing request (Error Code: -995)', //BMS Internal Error
    '-994': 'Conexão com o servidor perdida, aposta não registrada.',
    '-980': 'Error processing request (Error Code: -980)', //Error processing game command.
    '-979': 'Error processing request (Error Code: -979)', //Error on Json message sent by Virgo.
    '-978': 'Não há fundos suficientes para efetuar esta transação.',
    '-977': 'Falha no aviso de reality check.',
    '-976': 'Operações de carteira temporariamente bloqueadas.',
    '-975': 'Limite de apostas excedido.',
    '-974': 'Limite de perdas excedido.',
    '-973': 'Sem limite definido.',
    '-972': 'Erro de aposta responsável.',
    '-971': 'Falha nas operações de carteira.',
    '-970': 'Transação de carteira rejeitadas.',
    '-969': 'Erro de comunicação de carteira.',
    '-968': 'Erro de transação de carteira.',
    '-967': 'Falha na autenticação.',
    '-966': 'Limite de vitória alta excedido.',
    '-965': 'Parâmetros inválidos comunicados.',

    // BET LIMITS ALERTS
    BET_STAKE_OUT_OF_LIMITS_MESSAGE: 'Uma ou mais apostas não são válidas. Aposta mínima: {0}; aposta máxima: {1}. Corrija a situação antes de efetuar as suas apostas.',
    LIST_BET_STAKE_OUT_OF_LIMITS_MESSAGE: 'Stake limits on {0} are Min {1} & Max {2}',
    BET_POTENTIAL_RETURNS_OUT_OF_LIMITS_MESSAGE: 'Um ou mais potenciais lucros de apostas excedem o pagamento máximo de {0}. Corrija a situação antes de efetuar as suas apostas.',
    BET_NON_DIVISIBLE_MESSAGE: 'Uma ou mais apostas não são divisíveis por {0}. Corrija a situação antes de efetuar as suas apostas.',
    SINGLE_BET_COMMIT_MESSAGE: 'Você não pode efetuar várias apostas únicas',
    REALITY_CHECK_WARNING_MESSAGE_LINE_1: 'Aposta(s) efetuada(s) excede(m) {0}.',
    MIN_STAKE_REALITY_CHECK_WARNING_MESSAGE_LINE_1: 'The bet(s) you are placing are under {0}',
    REALITY_CHECK_WARNING_MESSAGE_LINE_2: 'Tudo certo?',
    REALITY_CHECK_TOTAL_STAKE_SINGLE_EVENT_WARNING: 'A quantia máxima de {0} foi apostada. Selecione um evento diferente',

    //SIMPLIFIED UI
    TOTAL_BETS: 'APOSTA TOTAL:',
    PLACE_YOUR_BETS: 'Faça as suas apostas',
    RACE_START: 'Race Start',
    RACE_START_TIME: 'Start Time',
    BET_SUMMARY: 'Sumário da aposta',
    NO_BETS_RESUME: 'Nenhuma aposta foi efetuada no evento atual',
    LIVE: 'AO VIVO',
    RACERS: 'Corredores',
    SELECTION: 'Seleção',
    DATE_LOCATION: 'Evento',
    STAKE: 'Participação',
    BET_TYPE_STAKE: 'Tipo de aposta/participação',
    POTENTIAL_RETURNS: 'Pot. Returns',
    BET_HISTORY: 'Histórico de apostas',
    BET_HISTORY_LABEL: 'Para ver o histórico, clique no botão Histórico de apostas',
    FILTER_WINS: 'Filtrar prêmios',
    NEXT_RACE: 'Próxima corrida',
    WIN: 'Prêmios',
    PLACE: 'Posição',
    SHOW: 'Mostrar',
    EXACTA: 'Previsão',
    TRIFECTA: 'Previsão tripla',
    NO_WIN: 'SEM PRÊMIOS',
    WON: 'VITÓRIA',
    LOST: 'DERROTA',
    CURRENT_RACE: 'Corrida atual',
    BOX: 'BOX',
    TO: 'para',
    PAYS: 'paga',
    TRIFECTA_BOX: 'combination tricast',
    EXACTA_BOX: 'combination forecast',
    FINISH_YOUR_BETS: 'Finalize suas apostas',
    SELECT_YOUR_BET_BELOW: 'Selecione a sua aposta abaixo',
    BET: 'aposta',
    REMOVED: 'removido(s)',
    RESULT: 'Resultado',
    GOALS: 'Objetivos',
    NO_MORE_BETS: 'Sem mais apostas',
    EVENT_LIVE_MSG_LINE_1: 'Evento ao vivo atual',
    EVENT_LIVE_MSG_LINE_2: 'Selecionar do futuro ',
    EVENT_LIVE_MSG_LINE_3: 'Eventos acima',
    NO_FUTURE_EVENTS: 'Carregando',
    AUTHENTICATION_REQUIRED: 'Inicie sessão para continuar',
    GAME_DISABLED: 'Jogo desativado',
    GAME_DISABLED_MESSAGE: 'Entre em contato com o atendimento ao cliente.',
    VOIDED: 'ANULADO(A)',
    HELP: 'Ajuda',
    LAST_RESULTS: 'Últimos resultados',
    NO_LAST_RESULTS: 'Sem últimos resultados',
    PREVIOUS_RESULTS: 'Resultados anteriores',
    OFFENSE_PREVIOUS_RESULTS: 'Offence Previous Results',
    DEFENSE_PREVIOUS_RESULTS: 'Defence Previous Results',
    NO_LUCK: 'NO LUCK',
    THIS_TIME: 'THIS TIME',
    LOOK_FOR_THE_NEXT: 'Procurar o próximo',
    SCHEDULED_EVENT: 'evento agendado',
    LOOK_FOR_THE: 'Procurar',
    NEXT_SCHEDULED: 'próximo',
    EVENT: 'evento agendado',
    RETURNS: 'LUCROS',
    NEXT: 'Seguinte',
    FUTURE: 'Futuro',
    PLAYING: 'Jogando',

    //MESSAGE BAR
    ON: 'em',
    MB_RACE_ON: 'em',
    MB_RACE_WIN: 'a ganhar',
    MB_RACE_PLACE: 'a realizar',
    MB_RACE_SHOW: 'a mostrar',
    MB_RACE_TRIFECTA_BOX: 'combination tricast',
    MB_RACE_EXACTA_BOX: 'combination forecast',
    MB_RACE_EXACTA: 'forecast',
    MB_RACE_TRIFECTA: 'tricast',
    MB_FOOTBALL_ON: 'em',

    // DESKTOP UI
    ADVERTISING_SPACE: 'ADVERTISING SPACE',
    CLEAR_LAST: 'Limpar última',
    CLEAR_ALL: 'Limpar tudo',
    ACTIVE_BETS: 'Apostas ativas',
    ONLY_SHOW_WINS: 'Mostrar apenas vitórias',
    MORE: 'Mais',
    BETS: 'Apostas',
    LOADING: 'Carregando',
    BET_SELECTION_MESSAGE: 'Faça a sua seleção clicando nas probabilidades.',

    // BUTTONS
    SIMPLE: 'simple',
    EXOTIC: 'exotic',
    UNDO: 'undo',
    CLEAR: 'clear',
    HISTORY: 'histórico',

    MARKETS: 'Mercados',
    MAIN: 'Principal',
    VS: 'vs.',
    AT: '@',
    SCORE: 'pontuação',
    DEFENDS: '(Defends) at',
    ATTACKS: '(Attacks) at',
    DETAILS: 'Detalhes',
    NO_GOALS: 'Sem gols',

    MAX_WINNINGS_REACHED: 'Máximo de vitórias alcançado',
    MAX_WINNINGS_REACHED_TEXT: 'A aposta atual excederá o pagamento máximo de {0}. O valor máximo de participação permitido para esta aposta é {1}.',
    NO_CONNECTION_TITLE: 'Conexão perdida.',

    NO_CONNECTION_TITLE_TEXT: 'Conexão com o servidor perdida, verifique se possui uma conexão de rede estável e atualize a página. Se o problema persistir, entre em contato com o atendimento.',
    PLAYER_LOGGED_OTHER_PLACE_TITLE_TEXT: 'Conexão desligada, usuário conectado duas vezes.',
    BET_CONFIRMED_TEXT:'nenhum(a)',
    TAX_NOTIFICATION_TEXT: 'nenhum(a)',
    //Event title names
    //Football
    'THE MANOR GROUND': 'Berners Stadium',
    'METRO STADIUM': 'Metro Stadium',

    //Horses Sprints
    'HorsesSprints': 'Wetmore Sprints',
    'Showell Park': 'Showell Park',
    '2FurlongHorses': 'Wetmore Sprints',
    'Sandringham Flats': 'Sandringham Flats',
    'Princess Parkway': 'Princess Parkway',

    //BasketBall
    'Virtual Arena': 'Virtual Arena',
    'Inspired Arena': 'Inspired Arena',
    //Horses Jumps
    'HorsesJumps': 'Inspired Downs',

    //Dogs
    'DogFlat': 'Barking Green',
    'Dogs2': 'Barking Green',
    'Victoria Park': 'Victoria Park',
    'Jennison Stadium': 'Jennison Stadium',

    //Motor Racing
    'Circuit': 'Circuit',

    //Speedway Park
    'Speedway Park': 'Inspired Raceway',
    'Auto Raceway': 'Auto Raceway',

    'NO_CONNECTION_TO_VIRGO': 'Conexão perdida',
    'NO_CONNECTION_TO_VIRGO_TEXT': 'Atualize a página e inicie a sessão.',
    'BROWSER_NOT_SUPPORTED_DETAILS': 'O seu navegador atual não é suportado. Use um dos seguintes navegadores: Chrome, Firefox ou Safari.',
    'BROWSER_NOT_SUPPORTED': 'Navegador não suportado',
    'DOWNLOAD_CHROME': 'Baixar Chrome',
    'DOWNLOAD_FIREFOX': 'Baixar Firefox',
    'v': 'V',
    '1': '1',
    'x': 'x',
    '2': '2',
    'at': '@',
    '+10.5': '+10.5',
    '+15.5': '+15.5',
    '+5.5': '+5.5',
    '-10.5': '-10.5',
    '-15.5': '-15.5',
    '-5.5': '-5.5',
    'Over 219.5': 'Acima de 219.5',
    'Under 219.5': 'Abaixo de 219.5',
    'Over 214.5': 'Acima de 214.5',
    'Under 214.5': 'Abaixo de 214.5',
    'Over 209.5': 'Acima de 209.5',
    'Under 209.5': 'Abaixo de 209.5',
    'Over 144.5': 'Acima de 144.5',
    'Under 144.5': 'Abaixo de 144.5',
    'Over 149.5': 'Acima de 149.5',
    'Under 149.5': 'Abaixo de 149.5',
    'Over 154.5': 'Acima de 154.5',
    'Under 154.5': 'Abaixo de 154.5',
    'Over 159.5': 'Acima de 159.5',
    'Under 159.5': 'Abaixo de 159.5',
    'Over 164.5': 'Acima de 164.5',
    'Under 164.5': 'Abaixo de 164.5',
    'Rolling Downs': 'Rolling Downs',
    'FINISHING_ORDER': 'Ordem de chegada',
    'FORECAST_MARBLE': 'Top 2',
    'TRICAST_MARBLE': 'Top 3',
    'REVERSE_FORECAST_MARBLE': 'Top 2 por qualquer ordem',
    'REVERSE_TRICAST_MARBLE': 'Top 3 por qualquer ordem',
    'TO_WIN_MARBLE': 'Prêmios',
    'PLACE_MARBLE': 'Posição',
    'SHOW_MARBLE': 'Mostrar',
    'MARBLE': 'Marble',
    'Rumble Turns': 'Rumble Turns',
    'Maple Downs': 'Maple Downs',

    //Header
    'BALANCE': 'Saldo',
    'DATE_FORMAT': 'DD/MM/YYYY HH:mm',
    'WINS_THE_GAME': 'Wins The Game',
    'Any': 'Qualquer',
    "BET_BOTH": "Apostar ambos",
    //Matchday
    "betSlip_Matchday_English": "Matchday English",
    "betSlip_Matchday_Turkish": "Matchday Turkish",
    "betSlip_Matchday_Greek": "Matchday Greek",
    "betSlip_Soccer": "Futebol",
    "betSlip_Horses": "Cavalos",
    "betSlip_Basketball": "Basquetebol",
    "betSlip_Dogs": "Cães",
    "betSlip_Motor Racing": "Corridas motorizadas",
    "betSlip_US Football": "Futebol EUA",
    "betSlip_Marble Racing": "Corrida de bolinhas",
    "POS": "pos.",
    "TEAM": "equipe",
    "P": "p",
    "W": "v",
    "D": "e",
    "L": "d",
    "F": "f",
    "A": "c",
    "PTS": "pts",
    "LEAGUE TABLE": "tabela da liga",
    "TREND": "tendência",

    //Matchday English Teams
    "Matchday_Islington": "ISL",
    "Matchday_City": "CTY",
    "Matchday_Palace": "PAL",
    "Matchday_Chelsea": "CHE",
    "Matchday_Southampton": "SOU",
    "Matchday_Wolverhampton": "WOL",
    "Matchday_Sheffield": "SHE",
    "Matchday_Leicester": "LEI",
    "Matchday_Newcastle": "NEW",
    "Matchday_Tottenham": "TOT",
    "Matchday_West Ham": "WHA",
    "Matchday_United": "UTD",
    "Matchday_Leeds": "LEE",
    "Matchday_Liverpool": "LIV",
    "Matchday_Everton": "EVE",
    "Matchday_Aston": "AST",

    //Matchday Turkish Teams
    "Matchday_Basaksehir": "BAS",
    "Matchday_Trabzon": "TRZ",
    "Matchday_Besiktas": "BKS",
    "Matchday_Sivas": "SIV",
    "Matchday_Alanya": "ALA",
    "Matchday_Galata": "GLS",
    "Matchday_Fenerbahce": "FRB",
    "Matchday_Gazientep": "GAZ",
    "Matchday_Antalya": "ANT",
    "Matchday_Kasimpasa": "KAS",
    "Matchday_Goztepe": "GOZ",
    "Matchday_Gencler": "ESK",
    "Matchday_Konya": "BUR",
    "Matchday_Rize": "RIZ",
    "Matchday_Malatya": "MAL",
    "Matchday_Kayseri": "KAY",

    //Matchday Greek Teams
    "Matchday_Dikefalos Vora": "ΔΙΚ",
    "Matchday_Erithrolefkoi": "ΘΡΥ",
    "Matchday_Enosi": "ΕΝΩ",
    "Matchday_Peristeri": "ΠΕΡ",
    "Matchday_Prasinoi": "ΠΡΑ",
    "Matchday_Kitrinoi Vora": "ΚΙΤ",
    "Matchday_Nea Smirni": "ΣΜΥ",
    "Matchday_Xanthi": "ΞΑΝ",
    "Matchday_Tripoli": "ΤΡΙ",
    "Matchday_Agrinio": "ΑΓΡ",
    "Matchday_Larisa": "ΛΑΡ",
    "Matchday_Lamia": "ΛΑΜ",
    "Matchday_Ioannina": "ΙΩΑ",
    "Matchday_Iraklio": "ΗΡΑ",
    "Matchday_A.O. Rizoupolis": "ΡΙΖ",
    "Matchday_Volos": "ΒΟΛ",

    //Soccer3 Greek Teams
    "Dikefalos Vora": "ΔΙΚ",
    "Erithrolefkoi": "ΘΡΥ",
    "Enosi": "ΕΝΩ",
    "Peristeri": "ΠΕΡ",
    "Prasinoi": "ΠΡΑ",
    "Kitrinoi Vora": "ΚΙΤ",
    "Nea Smirni": "ΣΜΥ",
    "Xanthi": "ΞΑΝ",
    "Tripoli": "ΤΡΙ",
    "Agrinio": "ΑΓΡ",
    "Larisa": "ΛΑΡ",
    "Lamia": "ΛΑΜ",
    "Ioannina": "ΙΩΑ",
    "Iraklio": "ΗΡΑ",
    "A.O. Rizoupolis": "ΡΙΖ",
    "Volos": "ΒΟΛ",

    "Dortmund": "Dortmund",
    "Chelsea": "Chelsea",
    "Porto": "Porto",
    "Rome": "Rome",
    "Benfica": "Benfica",
    "Celtic": "Celtic",
    "United": "United",
    UNDER_OVER_MATCHDAY: 'Acima/Abaixo',
    UNDER_OVER_05_SHORT: "0.5",
    UNDER_OVER_15_SHORT: "1.5",
    UNDER_OVER_25_SHORT: "2.5",
    UNDER_OVER_35_SHORT: "3.5",
    UNDER_SHORT: "A",
    OVER_SHORT: "A",
    "FULL TIME": "TEMPO COMPLETO",
    "FT": "TC",
    "System": "SISTEMA",
    "x1": "(x1)",
    "Multiplier": "Repeat Bet",
    "Main markets": "PRINCIPAIS MERCADOS",
    "4RANDOM": "4 ALEATÓRIAS",
    "6RANDOM": "6 ALEATÓRIAS",
    "8RANDOM": "8 ALEATÓRIAS",
    "8FAVS": "8 FAVORITAS",
    "QUICK_SELECT": "SELEÇÃO RÁPIDA",
    "UNDER": "UNDER",
    "OVER": "OVER",
    "UNDER_OVER_2_5": "Acima/Abaixo 2.5",
    "UNDER_OVER_3_5": "Acima/Abaixo 3.5",
    "MATCH_RESULT": "Resultado da partida",
    "YES": "YES",
    "NO": "NO",
    "REALITY_CHECK_WARNING_YES": "Yes",
    "REALITY_CHECK_WARNING_NO": "No",
    "ACCUMULATOR": "Acumulador",
    "+1G": "+1G",
    "Single": "Única",
    "Doubles": "Dupla(s)",
    "Trebles": "Tripla(s)",
    "Four Folds": "4 seleções",
    "Five Folds": "5 seleções",
    "Six Folds": "6 seleções",
    "Seven Folds": "7 seleções",
    "Eight Folds": "8 seleções",
    "MD": "MD{0}",
    "MATCH": "PARTIDA",
    "INVALID_ACCA": "Onde as seleções aparecem realçadas, múltiplas seleções são limitadas",
    "INVALID_ODDS": "O valor das probabilidades é alto demais. Altere suas seleções",
    "INVALID_ACCA_MORETHAN_8": "Apostas múltiplas não podem conter mais de 8 seleções em uma única partida",

    // Accumulator Boost
    "ACCUMULATOR_BOOST": 'Reforço de acumulador',
    "Bonus_Info": " Bônus de {0}%",
    "+": "+",
    "Bonus_Value": "Bônus de {0} incl.",
    "ACCUMULATOR_INFO": 'Se a sua aposta com acumulador concluir com sucesso, um bônus de {0}% - {1}% é adicionado a seus lucros. O valor do bônus depende do número de seleções.',
    "BET_TYPE": 'Tipo de aposta',
    "BOOST": 'Reforço',
    "BOOST_PERCENTAGE": '{0}%',
    "BOOST_BONUS_START": '{0} ou mais acumuladores de seleção receberão um bônus',
    "BOOST_BONUS_UPGRADE": 'Adicione outra seleção do acumulador para receber um bônus adicional',
    "BOOST_BONUS_MAX": 'Você está com o bônus máximo do acumulador.',
    "Marbles_Euro_1": "Belgium",
    "Marbles_Euro_2": "Croatia",
    "Marbles_Euro_3": "Denmark",
    "Marbles_Euro_4": "England",
    "Marbles_Euro_5": "France",
    "Marbles_Euro_6": "Germany",
    "Marbles_Euro_7": "Italy",
    "Marbles_Euro_8": "Netherlands",
    "Marbles_Euro_9": "Portugal",
    "Marbles_Euro_10": "Spain",
    "Short_Over": "Acima de {0}",
    "Short_Under": "Abaixo de {0}",
    "DEMOPLAY_NOTIFICATION_MESSAGE_LINE_1": "Registre-se ou inicie sessão para efetuar uma aposta",
    "DEMOPLAY_NOTIFICATION_MESSAGE_LINE_2": " ",
    "DEMOPLAY_NOTIFICATION_DISMISS": "Dispensar",
    "DEMOPLAY_NOTIFICATION_OK": "OK",
    "Matchday_Moroccan": "Matchday Moroccan",
    "Matchday_Moroccan_Matchday_Moroccan": "Matchday Moroccan",
    "betSlip_Matchday_Moroccan": "Matchday Moroccan",

    //Matchday Moroccan Teams
    "Matchday_Casa Reds": "WYD",
    "Matchday_Casa Greens": "RAJ",
    "Matchday_Fès": "FES",
    "Matchday_El Jadida": "ELJ",
    "Matchday_Berkane": "BKN",
    "Matchday_Feth": "FTH",
    "Matchday_FARabat": "FAR",
    "Matchday_Mohammedia": "MOH",
    "Matchday_Soualem": "SLM",
    "Matchday_Khouribga": "KHO",
    "Matchday_Tanger": "TAN",
    "Matchday_Agadir": "AGA",
    "Matchday_Berrechid": "BER",
    "Matchday_Oujda": "OUJ",
    "Matchday_Safi": "SAF",
    "Matchday_Oued Zem": "ODZ",
    "Matchday_Tétouan": "TET",
    "Matchday_Touarga": "TRG",
    "Matchday_Beni Mellal": "BNM",
    "Matchday_Stade Maroc": "STM",
    "Matchday_Zemamra": "ZMR",

    "Soccer_Soccer3_Moroccan_League": "Moroccan",
    //Soccer3 Moroccan Teams
    "Casa Reds": "Casa Reds",
    "Casa Greens": "Casa Greens",
    "Fès": "Fès",
    "El Jadida": "El Jadida",
    "Berkane": "Berkane",
    "Feth": "Feth",
    "FARabat": "FARabat",
    "Mohammedia": "Mohammedia",
    "Soualem": "Soualem",
    "Khouribga": "Khouribga",
    "Tanger": "Tanger",
    "Agadir": "Agadir",
    "Berrechid": "Berrechid",
    "Oujda": "Oujda",
    "Safi": "Safi",
    "Oued Zem": "Oued Zem",
    "Tétouan": "Tétouan",
    "Touarga": "Touarga",
    "Beni Mellal": "Beni Mellal",
    "Stade Maroc": "Stade Maroc",
    "Zemamra": "Zemamra",
    "QUICK_FILL": "Quick Fill",
    "MAD" : "{0} MAD",

    //Matchday Belgium
    "Matchday_Belgium": "Matchday",
    "Matchday_Belgium_Matchday_Belgium": "Matchday",
    "betSlip_Matchday_Belgium": "Matchday Belgium",
    //Matchday Belgium Teams
    "Matchday_Saint-Gilles": "SAI",
    "Matchday_Club": "CLU",
    "Matchday_Anderlecht": "AND",
    "Matchday_Antwerp": "ANT",
    "Matchday_Gent": "GEN",
    "Matchday_Mechelen": "MEC",
    "Matchday_Charleroi": "CHA",
    "Matchday_Genk": "GNK",
    "Matchday_Brugge": "BRU",
    "Matchday_Sint-Truiden": "SIN",
    "Matchday_Leuven": "LEU",
    "Matchday_Kortrijk": "KOR",
    "Matchday_Liege": "LIE",
    "Matchday_Oostende": "OOS",
    "Matchday_Waregem": "WAR",
    "Matchday_Eupen": "EUP",
    "Matchday_Seraing": "SER",

    //BonusBet
    "Gift_for_You_Heading" :"UM PRESENTE PARA VOCÊ",
    "Gift_for_You_Content": " Parabéns! Você tem ofertas promocionais para receber.",
    "View_Offers" : " VER OFERTAS",
    "Do_Not_Show_MSG": " NÃO MOSTRAR NOVAMENTE",
    "MY_OFFERS" : ' MINHAS OFERTAS',
    "SELECT_OFFER" : ' SELECIONE A SUA OFERTA',
    "NO_OFFER" : ' NENHUMA OFERTA ATIVA',
    "CHOOSE_BET": ' ESCOLHER APOSTA',
    "Opt_In": ' ACEITAR',
    "Key_Terms_Heading" :"TERMOS ESSENCIAIS",
    "No_Thanks" : " NÃO, OBRIGADO",
    "PROMO_BET": ' APOSTA PROMOCIONAL',
    "Time_To_Bet": " HORA DA APOSTA",
    "OPTED_IN_MSG": " AGRADECEMOS POR ACEITAR",
    "EXP": "Exp.",
    "SELECT": "Select",
    "DEMO_SITE_PROMO_NOT_AVAILABLE": "This demo site does not currently offer any promos. Please log in/register to access current offers. !",
    "Horses_US_Horses": "USA",

    //cricket
    "Cricket" : "Cricket",
    "Cricket_International": "Internacional",
    "betSlip_Cricket": "Cricket",
    //circket teams
     "Australia":"Australia",
     "India":"India",
     "Pakistan":"Pakistan",
     "West Indies" : "West Indies",
     "Sri Lanka":"Sri Lanka",
     "New Zealand":"New Zealand",
     "South Africa":"South Africa",
     "Australia_short":"AUS",
     "WestIndies_short" : "WI",
     "SriLanka_short":"SRI",
     "NewZealand_short":"NZL",
     "India_short":"IND",
     "SouthAfrica_short":"RSA",
     "Pakistan_short":"PAK",
     "England_short": "ENG",
     "Tie":"Tie",
    //cricket markets
     "MATCH_WINNER":"Vencedor da partida",
     "TOTAL_SIXES_IN_MATCH":"Total de 6’ s da partida",
     "TOTAL_SIXES_IN_MATCH_SHORT": "Under 1.5",
     "TOTAL_FOUR_IN_MATCH":"Total de 4’ s da partida",
     "TOTAL_BOUNDARIES_IN_MATCH":"Total de limites (boundaries) da partida",
     "FIRST_TEAM_TOTAL_RUNS":"{0} Total de corridas",
     "FIRST_TEAM_RUNS_OFF_FIRST_BALL":"{0} Corridas para fora na primeira entrega",
     "FIRST_TEAM_WICKET_LOST":"{0} Wicket perdido",
     "FIRST_TEAM_WICKET_LOST_DISMISSAL_TYPE": "{0} Primeiro método de tipo de eliminação",
     "FIRST_TEAM_RUN_OFF_FIRST_BALL_OVER_UNDER_05_SHORT": "0.5",
     "FIRST_TEAM_RUNS_OFF_FIRST_BALL_OVER_UNDER_15_SHORT": "1.5",
     "FIRST_TEAM_RUNS_OFF_FIRST_BALL_OVER_UNDER_25_SHORT": "2.5",
     "FIRST_TEAM_RUNS_OFF_FIRST_BALL_OVER_UNDER_35_SHORT": "3.5",
     "FIRST_TEAM_RUNS_OFF_FIRST_BALL_UNDER_OVER":"{0} Corridas para fora na primeira bola over/under",
     "FIRST_TEAM_RUN_OFF_FIRST_BALL_OVER_UNDER_05": "{0} Corridas para fora na primeira bola over/under",
     "FIRST_TEAM_RUNS_OFF_FIRST_BALL_OVER_UNDER_15": "{0} Corridas para fora na primeira bola over/under",
     "FIRST_TEAM_RUNS_OFF_FIRST_BALL_OVER_UNDER_25": "{0} Corridas para fora na primeira bola over/under",
     "FIRST_TEAM_RUNS_OFF_FIRST_BALL_OVER_UNDER_35": "{0} Corridas para fora na primeira bola over/under",
     "Caught" : "Pego",
     "Bowled":"Arremessado",
     "LBW":"LBW",
     "No Wicket":"Sem wicket",
     "OverZeroPointFive": "Over 0.5",
     "UnderZeroPointFive": "Under 0.5",
     "OverOnePointFive": "Over 1.5",
     "UnderOnePointFive": "Under 1.5",
     "OverTwoPointFive": "Over 2.5",
     "UnderTwoPointFive": "Under 2.5",
     "OverThreePointFive": "Over 3.5",
     "UnderThreePointFive": "Under 3.5",
     "Yes": "Yes",
     "No":"No",
     "FINAL_SCORE":"Final Score",
      OVER_145: 'Over 14.5',
      UNDER_145: 'Under 14.5',
      DRAW_Cricket: "DRAW",
       //TENNIS
    TOTAL_POINTS:"Total de pontos",
    HANDICAP_TENNIS: "Handicap",
    Scotland :"Scotland",
    USA: "USA",
    Tennis_International: "Internacional",
    betSlip_Tennis: "Tênis",
    "Win By 2 or 3": "Ganhe com vantagem de 3 pontos ou menos",
    "Win By 4 or 5": "Ganhe com vantagem de 4 ou 5 pontos",
    "Win By 6 or 7": "Ganhe com vantagem de 6 ou 7 pontos",
    "Tennis": "Tennis",
   //baseball
    WINNER : "VENCEDOR",
    TOTAL_HOME_RUNS_UNDER_OVER: "TOTAL DE HOME RUNS 0/U",
    TOTAL_HOME_RUNS:  "TOTAL DE HOME RUNS EXATO",
    WINNER_AND_TOTAL_HOME_RUNS_OVER_UNDER:"VENCEDOR E TOTAL DE HOME RUNS A/A 5,5",
    WINNER_AND_TOTAL_HOME_RUNS_OVER_UNDER_SHORT:"Vencedor e Total de HR A/A 5,5",
    BATTER1_HOME_RUNS: "{0} HOME RUNS",
    BATTER2_HOME_RUNS: "{1} HOME RUNS",
    Baseball_HR_ShootOut_Legends: "Lendas da Disputa de Home Runs",
    Baseball_HR_ShootOut_Legends_SHORT: "Disputa de HR",
    "Baseball": "Beisebol",
    "betSlip_Baseball": "Beisebol",
    "Player 1 AND OVER_5_5":"{0} e acima de 5,5",
    "Player 2 AND OVER_5_5":"{0} e acima de 5,5",
    "Player 1 AND UNDER_5_5":"{0} e abaixo de 5,5",
    "Player 2 AND UNDER_5_5":"{0} e abaixo de 5,5",
    "Draw AND OVER_5_5":"Empate e acima de 5,5",
    "Draw AND UNDER_5_5":"Empate e abaixo de 5,5",
    "HOME RUNS":"{0} Home Runs",
    "Next Fixtures":"Next Fixtures",
    "MATCH_IN_PROGRESS": "Match In Progress",
    "Matchday_Light_English": "Matchday Light",
    "Matchday_Light_English_Matchday_Light_English": "English League",
    "betSlip_Matchday_Light_English": "Matchday Light",
     //NFL
    'Cardinals' : 'Cardinals',
    'Falcons' : 'Falcons',
    'Ravens' : 'Ravens',
    'Bills' : 'Bills',
    'Panthers' : 'Panthers',
    'Bears' : 'Bears',
    'Bengals' : 'Bengals',
    'Browns' : 'Browns',
    'Cowboys' : 'Cowboys',
    'Broncos' : 'Broncos',
    'Lions' : 'Lions',
    'Packers' : 'Packers',
    'Texans' : 'Texans',
    'Colts' : 'Colts',
    'Jaguars' : 'Jaguars',
    'Chiefs' : 'Chiefs',
    'Raiders' : 'Raiders',
    'Chargers' : 'Chargers',
    'Rams' : 'Rams',
    'Dolphins' : 'Dolphins',
    'Vikings' : 'Vikings',
    'Patriots' : 'Patriots',
    'Saints' : 'Saints',
    'Giants' : 'Giants',
    'Jets' : 'Jets',
    'Eagles' : 'Eagles',
    'Steelers' : 'Steelers',
    '49ers' : '49ers',
    'Seahawks' : 'Seahawks',
    'Buccaneers' : 'Buccaneers',
    'Titans' : 'Titans',
    'Commanders' : 'Commanders',
    'NEW' : 'New',
    //Soccer_Soccer3_Turkish_League team names and game name
    "Soccer_Soccer3_Turkish_League": "Turkish League",
    "Basaksehir": "BAS",
    "Trabzon": "TRZ",
    "Besiktas": "BKS",
    "Sivas": "SIV",
    "Alanya": "ALA",
    "Galata": "GLS",
    "Fenerbahce": "FRB",
    "Gazientep": "GAZ",
    "Antalya": "ANT",
    "Kasimpasa": "KAS",
    "Goztepe": "GOZ",
    "Gencler": "ESK",
    "Konya": "BUR",
    "Rize": "RIZ",
    "Malatya": "MAL",
    "Kayseri": "KAY",

    //NBA 
  "Basketball_NBA": "NBA",
  "Atlanta Hawks": "Atlanta Hawks",
  "Boston Celtics": "Boston Celtics",
  "Brooklyn Nets": "Brooklyn Nets",
  "Charlotte Hornets": "Charlotte Hornets",
  "Chicago Bulls": "Chicago Bulls",
  "Cleveland Cavaliers": "Cleveland Cavaliers",
  "Dallas Mavericks": "Dallas Mavericks",
  "Denver Nuggets": "Denver Nuggets",
  "Detroit Pistons": "Detroit Pistons",
  "Golden State Warriors": "Golden State Warriors",
  "Houston Rockets": "Houston Rockets",
  "Indiana Pacers": "Indiana Pacers",
  "Los Angeles Clippers": "Los Angeles Clippers",
  "Los Angeles Lakers": "Los Angeles Lakers",
  "Memphis Grizzlies": "Memphis Grizzlies",
  "Miami Heat": "Miami Heat",
  "Milwaukee Bucks": "Milwaukee Bucks",
  "Minnesota Timberwolves": "Minnesota Timberwolves",
  "New Orleans Pelicans": "New Orleans Pelicans",
  "New York Knicks": "New York Knicks",
  "Oklahoma City Thunder": "Oklahoma City Thunder",
  "Orlando Magic": "Orlando Magic",
  "Philadelphia 76ers": "Philadelphia 76ers",
  "Phoenix Suns": "Phoenix Suns",
  "Portland Trail Blazers": "Portland Trail Blazers",
  "Sacramento Kings": "Sacramento Kings",
  "San Antonio Spurs": "San Antonio Spurs",
  "Toronto Raptors": "Toronto Raptors",
  "Utah Jazz": "Utah Jazz",
  "Washington Wizards": "Washington Wizards",
  "TOTALPOINTS": "TOTAL POINTS"
};


// WEBPACK FOOTER //
// ./src/localization/pt_BR.js